import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
@Component({
    selector: 'app-delete-confirmation-dialog',
    templateUrl: './delete-confirmation-dialog.component.html',
    styleUrls: ['./delete-confirmation-dialog.component.scss']
})
export class GETDeleteConfirmationDialogComponent implements OnInit {

    constructor(public dialogRef: MatDialogRef<GETDeleteConfirmationDialogComponent>) { }

    ngOnInit() {
    }

    onCloseClick() {
        this.dialogRef.close({ data: { goAhead: false } });
    }

    onConfirmDeleteClick() {
        this.dialogRef.close({ data: { goAhead: true } });
    }
}
